import { useEffect, useRef } from "react";

const key = (uid) => `ec-draft-${uid || "anon"}`;

export const loadDraft = (uid) => { try { const v = JSON.parse(localStorage.getItem(key(uid)) || "null"); return v && v.draft ? v : null; } catch { return null; } };
export const clearDraft = (uid) => localStorage.removeItem(key(uid));

// Debounced autosave of the in-progress campaign to localStorage.
export function useAutosave(uid, draft, override, recipients, sendAt) {
  const t = useRef(null);
  useEffect(() => {
    if (!draft) return;
    if (t.current) clearTimeout(t.current);
    t.current = setTimeout(() => {
      try { localStorage.setItem(key(uid), JSON.stringify({ draft, override, recipients, sendAt, saved_at: new Date().toISOString() })); } catch { /* quota */ }
    }, 800);
    return () => t.current && clearTimeout(t.current);
  }, [uid, draft, override, recipients, sendAt]);
}
